import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    maxWidth: 352,
    maxHeight: 350,
    overflowY: "auto",
    backgroundColor: theme.palette.type === "dark" ? "#2b2b2b" : "#fff",
    border: `1px solid ${theme.palette.divider}`,
  },
  category: {
    marginBottom: theme.spacing(1),
  },
  categoryTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
  },
  emojiGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(8, 1fr)",
    gap: theme.spacing(0.5),
  },
  emojiButton: {
    fontSize: 24,
    padding: theme.spacing(0.5),
    cursor: "pointer",
    borderRadius: 4,
    transition: "background-color 0.2s",
    textAlign: "center",
    border: "none",
    background: "transparent",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const emojiCategories = [
  {
    name: "Smileys & People",
    emojis: [
      "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂",
      "🙂", "🙃", "😉", "😊", "😇", "🥰", "😍", "🤩",
      "😘", "😗", "☺️", "😚", "😙", "🥲", "😋", "😛",
      "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🤫", "🤔",
      "🤐", "🤨", "😐", "😑", "😶", "😏", "😒", "🙄",
      "😬", "🤥", "😌", "😔", "😪", "🤤", "😴", "😷",
      "🤒", "🤕", "🤢", "🤮", "🤧", "🥵", "🥶", "😶‍🌫️",
      "😵", "😵‍💫", "🤯", "🤠", "🥳", "😎", "🤓", "🧐",
    ],
  },
  {
    name: "Animals & Nature",
    emojis: [
      "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼",
      "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🐔",
      "🐧", "🐦", "🐤", "🦆", "🦅", "🦉", "🦇", "🐺",
      "🌸", "💐", "🌹", "🥀", "🌺", "🌻", "🌼", "🌷",
      "🌱", "🌲", "🌳", "🌴", "🌵", "🌾", "🌿", "☘️",
      "🍀", "🍁", "🍂", "🍃", "🌍", "🌎", "🌏", "🌑",
    ],
  },
  {
    name: "Food & Drink",
    emojis: [
      "🍎", "🍏", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓",
      "🍈", "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅",
      "🍆", "🥑", "🥦", "🥬", "🥒", "🌶️", "🌽", "🥕",
      "🍞", "🥖", "🥐", "🥯", "🥞", "🧇", "🧀", "🍖",
      "🍗", "🥩", "🥓", "🍔", "🍟", "🍕", "🌭", "🥪",
      "🌮", "🌯", "🥙", "🧆", "🥚", "🍳", "🥘", "🍲",
    ],
  },
  {
    name: "Activity",
    emojis: [
      "⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉",
      "🥏", "🎱", "🪀", "🏓", "🏸", "🏒", "🏑", "🥍",
      "🏏", "🥅", "⛳", "🪁", "🏹", "🎣", "🤿", "🥊",
      "🥋", "🎽", "🛹", "🛼", "🛷", "⛸️", "🥌", "🎿",
      "⛷️", "🏂", "🪂", "🏋️", "🤼", "🤸", "🤾", "🏌️",
      "🏇", "🧘", "🏄", "🏊", "🤽", "🚣", "🧗", "🚴",
    ],
  },
  {
    name: "Travel & Places",
    emojis: [
      "🚗", "🚕", "🚙", "🚌", "🚎", "🏎️", "🚓", "🚑",
      "🚒", "🚐", "🛻", "🚚", "🚛", "🚜", "🦯", "🦽",
      "🦼", "🛴", "🚲", "🛵", "🏍️", "🛺", "🚨", "🚔",
      "🚍", "🚘", "🚖", "🚡", "🚠", "🚟", "🚃", "🚋",
      "🚞", "🚝", "🚄", "🚅", "🚈", "🚂", "🚆", "🚇",
      "🚊", "🚉", "✈️", "🛫", "🛬", "🛩️", "💺", "🚁",
    ],
  },
  {
    name: "Objects",
    emojis: [
      "⌚", "📱", "📲", "💻", "⌨️", "🖥️", "🖨️", "🖱️",
      "🖲️", "🕹️", "🗜️", "💽", "💾", "💿", "📀", "📼",
      "📷", "📸", "📹", "🎥", "📽️", "🎞️", "📞", "☎️",
      "📟", "📠", "📺", "📻", "🎙️", "🎚️", "🎛️", "🧭",
      "⏱️", "⏲️", "⏰", "🕰️", "⌛", "⏳", "📡", "🔋",
      "🔌", "💡", "🔦", "🕯️", "🪔", "🧯", "🛢️", "💸",
    ],
  },
  {
    name: "Symbols",
    emojis: [
      "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍",
      "🤎", "💔", "❣️", "💕", "💞", "💓", "💗", "💖",
      "💘", "💝", "💟", "☮️", "✝️", "☪️", "🕉️", "☸️",
      "✡️", "🔯", "🕎", "☯️", "☦️", "🛐", "⛎", "♈",
      "♉", "♊", "♋", "♌", "♍", "♎", "♏", "♐",
      "♑", "♒", "♓", "🆔", "⚛️", "🉑", "☢️", "☣️",
    ],
  },
  {
    name: "Flags",
    emojis: [
      "🏁", "🚩", "🎌", "🏴", "🏳️", "🏳️‍🌈", "🏳️‍⚧️", "🏴‍☠️",
      "🇧🇷", "🇺🇸", "🇬🇧", "🇪🇸", "🇫🇷", "🇩🇪", "🇮🇹", "🇵🇹",
      "🇦🇷", "🇨🇱", "🇨🇴", "🇲🇽", "🇨🇦", "🇯🇵", "🇨🇳", "🇰🇷",
      "🇮🇳", "🇷🇺", "🇦🇺", "🇿🇦", "🇪🇬", "🇳🇬", "🇰🇪", "🇬🇭",
    ],
  },
];

const EmojiPicker = ({ onEmojiClick, theme = "dark" }) => {
  const classes = useStyles();

  const handleEmojiClick = (emoji) => {
    if (onEmojiClick) {
      onEmojiClick({ native: emoji });
    }
  };

  return (
    <Paper className={classes.root} elevation={3}>
      <Box>
        {emojiCategories.map((category) => (
          <div key={category.name} className={classes.category}>
            <div className={classes.categoryTitle}>{category.name}</div>
            <div className={classes.emojiGrid}>
              {category.emojis.map((emoji) => (
                <button
                  key={emoji}
                  className={classes.emojiButton}
                  onClick={() => handleEmojiClick(emoji)}
                  type="button"
                  aria-label={`Select ${emoji} emoji`}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        ))}
      </Box>
    </Paper>
  );
};

export default EmojiPicker;
